export const isTopVideo = (settings) => {
  const { video, topSection } = settings

  return !!(video && topSection && topSection.value === 'video')
}

export const isTopTour360 = (settings) => {
  const { tour360, topSection } = settings

  return !!(tour360 && topSection && topSection.value === 'tour360')
}

export const isTopBanner = (settings) => {
  const { topSection } = settings

  return !!(topSection && topSection.value === 'banner')
}
